module.exports = __webpack_public_path__ + "static/media/electronics.ee66dd8d.png";